<template>
  <div>
    <ProjectReportsDigitalMeterParentBar />
    <router-view ></router-view>
  </div>
</template>

<script>
import ProjectReportsDigitalMeterParentBar from "@/components/ProjectReportsDigitalMeterParentBar.component.vue";
export default {
  components: {
    ProjectReportsDigitalMeterParentBar,
  },
  data(){
    return {
      projectId: this.$route.params.projectId,
    }
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
  },
  created(){
    if(!(this.admins?.length)){
      this.$router.push(`/notFound`);
    }
  }
};
</script>

<style>
</style>